import React from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Profile from './PortfolioContainer/Home/Profile';
import Skills from './PortfolioContainer/Skills/Skills';
import Projects from './PortfolioContainer/Projects/Projects';
import ContactMe from './PortfolioContainer/ContactMe/ContactMe';
import Blog from './PortfolioContainer/Blog/Blog';
import Footer from './PortfolioContainer/Footer/Footer';
import Resume from './PortfolioContainer/Resume/Resume';

function App() {
  return (
    <div className='App'>
      <Router>
        <Switch>
          <Route exact path='/'>
            <Profile />
            <Skills />
            <Projects />
            <ContactMe />
            <Footer />
          </Route>
          <Route path='/home'>
            <Profile />
            <Skills />
            <ContactMe />
            <Footer />
          </Route>
          <Route path='/skills'>
            <Skills />
          </Route>
          <Route path='/resume'>
            <Resume />
          </Route>
          <Route path='/blog'>
            <Blog />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
